import { useState, useEffect } from 'react';

function ProgressBar({ steps = [], currentStep = 0, animated = false }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (animated) {
      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 95) {
            clearInterval(interval);
            return 95;
          }
          return prev + Math.random() * 8;
        });
      }, 500);
      return () => clearInterval(interval);
    } else if (steps.length > 0) {
      setProgress(((currentStep + 1) / steps.length) * 100);
    }
  }, [animated, currentStep, steps.length]);

  if (steps.length > 0 && !animated) {
    return (
      <div className="w-full">
        <div className="flex items-center justify-between mb-2">
          {steps.map((step, i) => (
            <div key={i} className="flex items-center">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition-all ${
                  i <= currentStep
                    ? 'bg-brand-orange text-white'
                    : 'bg-gray-200 text-gray-500'
                }`}
              >
                {i < currentStep ? (
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                ) : (
                  i + 1
                )}
              </div>
              {i < steps.length - 1 && (
                <div className={`h-0.5 w-12 sm:w-20 mx-1 transition-all ${
                  i < currentStep ? 'bg-brand-orange' : 'bg-gray-200'
                }`} />
              )}
            </div>
          ))}
        </div>
        <div className="flex justify-between">
          {steps.map((step, i) => (
            <span key={i} className={`text-xs ${i <= currentStep ? 'text-brand-orange font-medium' : 'text-gray-400'}`}>
              {step}
            </span>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="w-full">
      <div className="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-brand-orange to-brand-yellow rounded-full transition-all duration-500 ease-out"
          style={{ width: `${Math.min(progress, 100)}%` }}
        />
      </div>
      {animated && (
        <p className="text-xs text-gray-400 mt-1 text-right">{Math.round(progress)}%</p>
      )}
    </div>
  );
}

export default ProgressBar;
